import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect, Fragment } from "react";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Button, Divider, ListItem, ListItemText, List, AppBar, Toolbar, IconButton, Typography, Grid } from "@material-ui/core";

import { DialogContentText, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core'
import TextField from '@material-ui/core/TextField';

import Box from '@material-ui/core/Box';

import { member as v_member, basic, Values, SNACKBAR_TIME } from '../request/values';

import ToastStr from '../request/toastStr';
import { useSnackbar } from 'notistack';

import { COLORS } from './Theme'
import axios from "axios";
import { SIcon } from "./Icon";
import { DialogConfirm, DialogInput } from "./Dialog";
import { useHistory } from "react-router-dom";
import { TitleBackBar } from "./header/TitleBar";
import NumberFormat from "react-number-format";


const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    toolBar: {
        padding: 0,
    },
    back: {
        float: 'left',
        width: '10%',
    },
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        float: 'left',
        textAlign: 'center',
        width: '80%',
        justifyContent: 'center',
        "& img": {
            width: '6.5vw',
            height: '6.5vw',
        }
    },
    titleIcon: {
        width: 30,
        height: 30,
    },
    title: {
        fontSize: '6.5vw',
        fontWeight: 'bold',
        color: `${COLORS.WATER_BLUE}`,
        marginLeft: '2vw',
        // marginBottom: '0.5vh',
        // alignItems: 'center',
        // flexGrow: 1,
        // textAlign: 'center',
    },

    buttonSection: {
        textAlign: 'center',
        marginTop: '2vh',
        marginBottom: '1.5vh',
    },
    button: {
        width: '85%',
        height: '6vh',
        ...theme.typography.h3,
        fontFamily: 'NanumB',
        fontWeight: 'bold',

        borderRadius: '24px',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        // border: 'solid 0.5px #cfd4d9',
        [theme.breakpoints.up("md")]: {
          ...theme.typography.h3,
          fontFamily: 'NanumB',
          fontWeight: 'bold',
          maxWidth: '550px'
        }
    },



    table: {
        minWidth: 650,
    },
    tableCol1: {
        maxWidth: 150,
    },
    LoanTable: {
        width: '100%',
        height: '62vh',
        // maxHeight: '62vh',
        overflowY: 'auto',
        '& li': {
            backgroundColor: `${COLORS.LIGHT_GREY}`,
            borderRadius: 12,
            border: `solid 1px ${COLORS.VERY_LIGHT_PINK}`,
            marginBottom: '1.5vh',
            fontSize: '3.5vw',
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            color: `${COLORS.BROWNISH_GREY}`
        }
    },

    tableText: {
        width: '100%',
        ...theme.typography.subtitle2,
        color: `${COLORS.BROWNISH_GREY}`,
        borderColor: `${COLORS.BROWNISH_GREY}`,
        '& th, td': {
            padding: 7,
            ...theme.typography.subtitle2,
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },

    loanButton: {
        "& button": {
            borderRadius: '8.5px',
            ...theme.typography.subtitle1,
        },

    },

    empty: {
        height: '62vh',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        "& img": {
            width: "35vw",
            height: '35vw',
            marginBottom: '2.5vh',
            maxWidth:'270px',
            maxHeight:'270px'
        },
        "& h1": {
            color: `${COLORS.DOWN}`,
        }

    },

    loan: {
        width: '80vw',
        height: '30vw',
    },


  }));


type iLoanList = {
    loanNum: number,
    memberName: string,
    currentStock: number,
    loan: number,
    loanInterest: number,
    loanDate: string,
    payback: string,
}

const LoanList: React.FC<any> = props => {
    const classes = useStyles();

    const { member } = props;
    let history = useHistory()
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [loanList, setLoanList] = useState<iLoanList[]>([]);
    const [input, setInput] = useState<boolean>(false);
    // 0 = close, 1 = 요청 , 2 = 확인
    const [confirm, setConfirm] = useState<number>(0);
    const [item, setItem] = useState<number>(0);

    const handleClose = (key: string) => {
        if (key === 'input')
            setInput(prevState => !prevState);
        else if (key === 'confirm')
            setConfirm(prevState => 0);
    };

    const handleOpen = (key: string) => {
        if (key === 'input' && !input) {
            setInput(prevState => !prevState);
        }
    }

    const getLoanList = () => {
        let url = new URL(SERVER + v_member.member + v_member.company_loan_list);
        let params = { 'companyNum': member.companyNum, 'classCode': member.classCode }
        url.search = new URLSearchParams(params).toString();

        axios({
            method: "GET",
            withCredentials: true,
            url: url.toString(),
        })
            .then(res => res.data)
            .then((data) => {
                console.log('res data : ', data, data.loanList.length);
                if (data.code === Values.SUCCESS_CODE) {
                    setLoanList(data.loanList)
                }
            })
    }

    const action = (key: any) => (
        <Fragment>
            <Button onClick={() => { closeSnackbar(key) }}>
                Close
            </Button>
        </Fragment>
    );

    const postLoan = (e: any, loan: number) => {
        console.log(loan)
        axios({
            method: "POST",
            data: {
                'loan_price': loan,
                'company_num': member.companyNum,
                'member_name': member.name,
                'class_code': member.classCode,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.company_loan,
        })
            .then(res => res.data)
            .then((data) => {
                console.log('loan submit', data)
                if (data.code === Values.SUCCESS_CODE) {
                    if (data.loanList == null) {
                        enqueueSnackbar(ToastStr.LOAN_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    }
                    getLoanList();
                } else if (data.code === Values.OVER_LOAN_CODE) {
                    enqueueSnackbar(ToastStr.LOAN_OVER_LOAN_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                }
                else {
                    enqueueSnackbar(ToastStr.LOAN_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                }
            })
        handleClose('input');
    }

    const makeContext = (confirm: number, loanList: any): string => {
        console.log(confirm, loanList)
        if (confirm === 1 && loanList !== null) {
            console.log(loanList[confirm as number].loan + loanList[confirm as number].loanInterest + '원을 상환하시겠습니까?')
            return loanList[confirm as number].loan + loanList[confirm as number].loanInterest + '원을 상환하시겠습니까?'
        } else if (confirm === 2 && loanList !== null) {
            return loanList[confirm as number].loan + loanList[confirm as number].loanInterest + '원을 상환이 완료되었습니다'
        }

        else return ''
    }

    const AddComma = (num: number) => {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
    }

    const yesConfirm = () => {
        // confirm !== false && loanPayBack(loanList[confirm as number].loanNum, loanList[confirm as number].loan + loanList[confirm as number].loanInterest)
        if (confirm === 1) {
            loanPayBack(
                loanList[item].loanNum,
                loanList[item].loan + loanList[item].loanInterest
            )
        }

    }

    const loanPayBack = (loanNum: number, loan: number) => {
        setConfirm(0)
        axios({
            method: "POST",
            data: {
                'loan_num': loanNum,
                'company_num': member.companyNum,
                'payback_price': loan,
                'class_code': member.classCode,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.company_loan_payback
        })
            .then(res => res.data)
            .then((data: any) => {
                if (data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.LOAN_PAYBACK_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    setConfirm(2);
                    console.log(2)
                }
                else if (data.code === Values.CLASS_NO_START_CODE)
                    enqueueSnackbar(ToastStr.LOAN_CLASS_NO_START_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                else if (data.code === Values.CLASS_FINISH_CODE)
                    enqueueSnackbar(ToastStr.LOAN_CLASS_FINISH_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                else if (data.code === Values.INSUFFICIENT_CODE)
                    enqueueSnackbar(ToastStr.LOAN_INSUFFICIENT_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                else if (data.code === Values.FAIL_CODE)
                    enqueueSnackbar(ToastStr.LOAN_PAYBACK_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                else if (data.code === Values.EXCEPTION_CODE)
                    enqueueSnackbar(ToastStr.LOAN_PAYBACK_UPDATE_EXCEPTION_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                else
                    enqueueSnackbar(ToastStr.ERROR, { variant: "error", autoHideDuration: SNACKBAR_TIME, translate: "no" })

                console.log(data)
            }).then(() => {
                getLoanList();
            })
        // setConfirm(2)

    }

    useEffect(() => {
        getLoanList()
    }, [])
    return (
        <div className="content">

            <TitleBackBar history={history} title="대출현황" titleIcon="price" />

            {loanList.length != 0 ?
                <List className={classes.LoanTable}>
                    {loanList.map((item: any, index: number) => {
                        return <LoanItem item={item}
                            // payback={() => loanPayBack(item.loanNum, item.loan+item.loanInterest)} 
                            payback={() => {
                                setConfirm(1)
                                setItem(index)
                            }}
                        // payback={() => {console.log('payback')}} 
                        />
                    })}
                </List>

                : <div className={classes.empty}>
                    <div>
                        <img src="/images/empty_loan.webp" />
                        <Typography variant="h1">대출한 내역이 없습니다.</Typography>
                    </div>
                </div>}

            <div className={classes.buttonSection}>
                <Button onClick={() => handleOpen('input')} className={classes.button} style={{ backgroundColor: `${COLORS.PUMPKIN}`, color: `${COLORS.WHITE}` }}>대출하기</Button>
            </div>

            <DialogInput
                dialogStyle = {classes.loan}
                open={input}
                handleClose={() => handleClose('input')}
                title='대출할 금액을 입력해주세요.'
                yesConfirm={(e: any, loan: number) => postLoan(e, loan)}
                noConfirm={() => handleClose('input')}
            />
            <DialogConfirm
                open={confirm === 0 ? false : true}
                handleClose={() => handleClose('confirm')}
                title={''}
                // context={() => makeContext}
                context={confirm === 1
                    ? (loanList !== null && AddComma(loanList[item as number].loan + loanList[item as number].loanInterest) + '원을 상환하시겠습니까?')
                    : confirm === 2
                        ? (loanList !== null && AddComma(loanList[item as number].loan + loanList[item as number].loanInterest) + '원을 상환이 완료되었습니다')
                        : ''
                }
                yesConfirm={confirm !== 2 ? yesConfirm : handleClose('confirm')}
                noConfirm={() => handleClose('confirm')}
                alarm={confirm === 2 ? true : false}
            />

        </div>
    )
}

const LoanItem: React.FC<any> = (props) => {
    const classes = useStyles();
    const { item, payback } = props;

    const click = () => {
        console.log('click', item.payback)
        if (item.payback !== 'complete') {
            payback();
        }

    }

    return (
        <ListItem translate = "no">
            <Grid container>
                <Grid xs={6}>
                    <TableContainer component={Paper} style={{ boxShadow: 'none', backgroundColor: `${COLORS.LIGHT_GREY}` }}>
                        <Table>
                            <TableBody>
                                <TableRow className={classes.tableText}>
                                    <TableCell align="left" style={{ borderBottom: "none", paddingLeft: 0 }} component="th" scope="row">
                                        대출원금
                                    </TableCell>
                                    <TableCell align="right" style={{ borderBottom: "none" }}>
                                        <NumberFormat value={item.loan} displayType={'text'} thousandSeparator={true} suffix="원" />
                                    </TableCell>
                                </TableRow>
                                <TableRow className={classes.tableText}>
                                    <TableCell align="left" style={{ borderBottomColor: `${COLORS.BROWNISH_GREY}`, paddingLeft: 0 }} component="th" scope="row">
                                        대출이자
                                    </TableCell>
                                    <TableCell align="right" style={{ borderBottomColor: `${COLORS.BROWNISH_GREY}`, }}>
                                        <NumberFormat value={item.loanInterest} displayType={'text'} thousandSeparator={true} suffix="원" />
                                    </TableCell>
                                </TableRow>
                                {/* <Divider/> */}
                                <TableRow className={classes.tableText}>
                                    <TableCell align="left" style={{ borderBottom: "none", paddingLeft: 0 }} component="th" scope="row">
                                        합계금액
                                    </TableCell>
                                    <TableCell align="right" style={{ borderBottom: "none", color: `${COLORS.PUMPKIN}` }}>
                                        <NumberFormat value={item.loanInterest + item.loan} displayType={'text'} thousandSeparator={true} suffix="원" />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid xs={6} container direction="column" alignItems="flex-end" style={{ justifyContent: "space-around" }} >
                    <Grid item>
                      <Typography variant="body1">
                        {item.loanDate.substring(11, 16)}
                      </Typography>
                    </Grid>
                    <Grid item>
                        <div className={classes.loanButton}>
                            {item.payback === 'complete'
                                ? <Button disabled style={{ backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`, color: `${COLORS.WHITE}` }}>상환완료</Button>
                                : <Button onClick={() => click()} style={{ backgroundColor: `${COLORS.WATER_BLUE}`, color: `${COLORS.WHITE}` }}>상환하기</Button>
                            }
                        </div>
                    </Grid>

                </Grid>
            </Grid>

        </ListItem>
    )
}

export default LoanList;

// export default class LoanList extends React.Component<LoanListProps, LoanListState> {
//     constructor(props: LoanListProps) {
//         super(props);
//         this.state = {
//             companyNum: 0,
//             LoanList: [{
//                 loanNum: 0,
//                 memberName: '',
//                 currentStock: 0,
//                 loan: 0,
//                 loanInterest: 0,
//                 loanDate: '',
//                 payback: ''
//             }],
//             open: false,
//             loanPrice: 0,
//             snackbar: {
//                 open: false,
//                 setOpen: this.handleToastOpen,
//                 severity: 'success',
//                 text: 'test'
//             },
//         }

//         this.handleClickOpen = this.handleClickOpen.bind(this)
//         this.handleClickClose = this.handleClickClose.bind(this)
//         this.handleFormSubmit = this.handleFormSubmit.bind(this)
//         this.handleValueChange = this.handleValueChange.bind(this)
//         this.handleToastOpen = this.handleToastOpen.bind(this)
//         this.buildToast = this.buildToast.bind(this)
//     }

//     handleToastOpen(b: boolean) {
//         const { snackbar } = { ...this.state };
//         const currentState = snackbar;

//         currentState['open'] = b;
//         this.setState({ snackbar: currentState });
//     }

//     buildToast(severity: Color, text: string) {
//         const { snackbar } = { ...this.state };
//         const currentState = snackbar;

//         currentState['severity'] = severity;
//         currentState['text'] = text;
//         this.handleToastOpen(true);
//     }

//     handleClickOpen() {
//         this.setState({
//             open: true
//         })
//     }

//     handleClickClose() {
//         this.setState({
//             open: false
//         })
//     }

//     handleFormSubmit(e: any) {
//         const member = getMember()

//         if (this.state.loanPrice > 0) {
//             this.handleClickClose()
//             // const requestOption = {
//             //     method: "POST",
//             //     headers: {
//             //         "Content-Type": "application/json; charset=utf-8"
//             //     },
//             //     body: JSON.stringify({
//             //         'loan_price': this.state.loanPrice,
//             //         'company_num': member.companyNum,
//             //         'member_name': member.name,
//             //         'class_code': member.classCode,
//             //     })

//             // }
//             // fetch('http://localhost:3001/v3/member/company/loan', requestOption)
//             axios({
//                 method: "POST",
//                 data: {
//                     'loan_price': this.state.loanPrice,
//                     'company_num': member.companyNum,
//                     'member_name': member.name,
//                     'class_code': member.classCode,
//                 },
//                 withCredentials: true,
//                 // url: http://localhost:3001/v3/member/company/loan',
//                 url: SERVER + v_member.member + v_member.company_loan,
//             })
//                 .then(res => res.data)
//                 .then((data) => {
//                     console.log('loan submit', data)
//                     if (data.code === Values.SUCCESS_CODE) {
//                         if (data.loanList == null) {
//                             this.buildToast("success", ToastStr.LOAN_SUCCESS_STR)
//                         }
//                     } else {
//                         this.buildToast("error", ToastStr.LOAN_FAIL_STR);
//                     }
//                 }).then(() => {
//                     this.getLoanList();
//                 })
//         } else {
//             this.buildToast("warning", ToastStr.LOAN_PRICE_INVALID_STR)
//         }


//     }

//     handleValueChange(e: React.ChangeEvent<HTMLInputElement>) {
//         if (e.target.value == '' || parseInt(e.target.value) >= 0) {
//             this.setState({
//                 loanPrice: parseInt(e.target.value)
//             });
//         }
//     }


//     getLoanList = () => {
//         const memberString: any = localStorage.getItem('member')
//         const member: any = memberString ? JSON.parse(memberString) : null;

//         const requestOption = {
//             method: "GET",
//             headers: {
//                 "Content-Type": "application/json; charset=utf-8"
//             },
//             body: JSON.stringify({
//                 'loan_price': this.state.loanPrice,
//                 'company_num': member.company_num,
//                 'member_name': member.name,
//                 'class_code': member.class_code,
//             })

//         }

//         // let url = new URL("http://localhost:3001/v3/member/company/loan/list");
//         let url = new URL(SERVER + v_member.member + v_member.company_loan_list);
//         let params = { 'companyNum': member.companyNum }
//         url.search = new URLSearchParams(params).toString();

//         // fetch(url.toString()).then((res) => {
//         //     console.log('response : ', res);
//         //     return res.json()
//         // })
//         axios({
//             method: "GET",
//             withCredentials: true,
//             url: url.toString(),
//         })
//             .then(res => res.data)
//             .then((data) => {
//                 console.log('res data : ', data);
//                 if (data.code === Values.SUCCESS_CODE) {
//                     if (data.loanList == null) {
//                         this.buildToast("warning", ToastStr.LOAN_LIST_FAIL_STR)
//                     }
//                 }
//                 this.setState({
//                     LoanList: data.loanList
//                 })
//             })
//     }

//     componentDidMount() {
//         this.getLoanList();
//     }



//     render() {
//         const { LoanList, snackbar } = this.state;
//         return (
//             <div>
//                 <LoanTable LoanList={LoanList} getLoanList={this.getLoanList} buildToast={this.buildToast}></LoanTable>
//                 <Box mt={5} bottom={50}>
//                     <Button variant="contained" color="primary" onClick={this.handleClickOpen} >
//                         대출하기
//                     </Button>
//                     <Dialog open={this.state.open} onClose={this.handleClickClose}>
//                         <DialogTitle>대출 금액을 입력해 주세요.</DialogTitle>
//                         <DialogContent>
//                             <TextField id="standard-number" label="대출금" type="number" name="loan_price" value={this.state.loanPrice} onChange={this.handleValueChange} /><br />
//                         </DialogContent>
//                         <DialogActions>
//                             <Button variant="contained" color="primary" onClick={this.handleFormSubmit}>네</Button>
//                             <Button variant="outlined" color="primary" onClick={this.handleClickClose} >아니오</Button>
//                         </DialogActions>
//                     </Dialog>
//                 </Box>
//                 <CustomSnackBar
//                     open={snackbar.open}
//                     setOpen={this.handleToastOpen}
//                     severity={snackbar.severity}
//                     text={snackbar.text}
//                 ></CustomSnackBar>

//             </div>

//         )
//     }


// }

// function createLoanTable(Loan: iLoan) {
//     let loanNum = Loan.loanNum
//     let memberName = Loan.memberName
//     let currentStock = Loan.currentStock;
//     let loan = Loan.loan;
//     let loanInterest = Loan.loanInterest;
//     let loanDate = Loan.loanDate;
//     let payback = Loan.payback;

//     return { loanNum, memberName, currentStock, loan, loanInterest, loanDate, payback }
// }

// interface iLoanTable {
//     LoanList: Array<iLoan>,
//     getLoanList: () => void,
//     buildToast: (severity: Color, text: string) => void,
// }

// const LoanTable: React.FC<iLoanTable> = (props) => {
//     const classes = useStyles();

//     return (
//         <List className={classes.LoanTable}>
//             {props.LoanList.map((loanItem: iLoan) => {
//                 return <LoanItem item={loanItem} getLoanList={props.getLoanList} buildToast={props.buildToast}></LoanItem>
//             })}
//         </List>
//     )
// }

// interface iLoanItem {
//     item: iLoan,
//     getLoanList: () => void,
//     buildToast: (severity: Color, text: string) => void,
// }

// const LoanItem: React.FC<iLoanItem> = (props) => {
//     const [dialogState, setDialogState] = useState<boolean>(false);
//     let disabled = false;
//     if (props.item.payback == 'complete') disabled = true;

//     const classes = useStyles();

//     const handleClose = () => {
//         setDialogState(false);
//     };

//     const handleOpen = () => {
//         if (!dialogState && !disabled) {
//             setDialogState(true);
//         }
//     }

//     const loanPayback = () => {
//         handleClose();
//         const member = getMember()

//         // const requestOption = {
//         //     method: "POST",
//         //     headers: {
//         //         "Content-Type": "application/json; charset=utf-8"
//         //     },
//         //     body: JSON.stringify({
//         //         'loan_num': props.item.loanNum,
//         //         'company_num': member.companyNum,
//         //         'payback_price': props.item.loan,
//         //         'class_code': member.classCode,
//         //     })

//         // }

//         // console.log(requestOption.body);

//         // const url = 'http://localhost:3001/v3/member/company/loan/payback';
//         // fetch(url, requestOption).then((res)=> {
//         //     return res.json()
//         // })
//         axios({
//             method: "POST",
//             data: {
//                 'loan_num': props.item.loanNum,
//                 'company_num': member.companyNum,
//                 'payback_price': props.item.loan,
//                 'class_code': member.classCode,
//             },
//             withCredentials: true,
//             // url: url,
//             url: SERVER + v_member.member + v_member.company_loan_payback
//         })
//             .then(res => res.data)
//             .then((data: any) => {
//                 if (data.code === Values.SUCCESS_CODE)
//                     props.buildToast("success", ToastStr.LOAN_PAYBACK_SUCCESS_STR);
//                 else if (data.code === Values.CLASS_NO_START_CODE)
//                     props.buildToast("warning", ToastStr.LOAN_CLASS_NO_START_STR);
//                 else if (data.code === Values.CLASS_FINISH_CODE)
//                     props.buildToast("warning", ToastStr.LOAN_CLASS_FINISH_STR);
//                 else if (data.code === Values.INSUFFICIENT_CODE)
//                     props.buildToast("warning", ToastStr.LOAN_INSUFFICIENT_STR);
//                 else if (data.code === Values.FAIL_CODE)
//                     props.buildToast("warning", ToastStr.LOAN_PAYBACK_FAIL_STR);
//                 else if (data.code === Values.EXCEPTION_CODE)
//                     props.buildToast("warning", ToastStr.LOAN_PAYBACK_UPDATE_EXCEPTION_STR);
//                 else
//                     props.buildToast("error", ToastStr.ERROR);

//                 console.log(data)
//             }).then(() => {
//                 props.getLoanList();
//             })


//     }



//     return (
//         <ListItem
//             onClick={handleOpen}
//             key={props.item.loanNum}
//             disabled={disabled}
//         >
//             <TableContainer component={Paper}>
//                 <Table className={classes.table} size="small">
//                     <TableRow>
//                         <TableCell align="right">{props.item.loanDate.substring(0, 10)}</TableCell>
//                         <TableCell align="right">대출원금</TableCell>
//                         <TableCell align="right">{props.item.loan}</TableCell>
//                     </TableRow>
//                     <TableRow>
//                         <TableCell align="right">{props.item.loanDate.substring(11, 16)}</TableCell>
//                         <TableCell align="right">대출이자</TableCell>
//                         <TableCell align="right">{props.item.loanInterest}</TableCell>
//                     </TableRow>
//                     <TableRow>
//                         <TableCell align="right"></TableCell>
//                         <TableCell align="right">합계금액</TableCell>
//                         <TableCell align="right">{props.item.loanInterest + props.item.loan}</TableCell>
//                     </TableRow>
//                 </Table>

//             </TableContainer>
//             <Dialog open={dialogState} onClose={handleClose}>
//                 <DialogTitle>대출금을 상환하시겠습니까?</DialogTitle>
//                 <DialogContent>
//                     <DialogContentText id="alert-dialog-description">
//                         {props.item.loanInterest + props.item.loan}원을 상환합니다.
//                     </DialogContentText>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button variant="contained" color="primary" onClick={loanPayback}>네</Button>
//                     <Button variant="outlined" color="primary" onClick={handleClose} >아니오</Button>
//                 </DialogActions>
//             </Dialog>

//         </ListItem>
//     )
// }

